import React from 'react';
import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import StandardDialog from './StandardDialog';


const DialogConfirm = ( { open, title, description, onCloseDialog, onAceptDialog }) => {
    return (
        <StandardDialog
            open = { open}
            title = { title }
            handleClose = { onCloseDialog }
            fullScreen = {false}
        >
            <DialogContentText id="alert-dialog-description">
                {<b>{description}</b>}
            </DialogContentText>
            <Grid container spacing={3}>
                <Grid item xs={6} md={6}>
                    <Button 
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={{borderLeft: '3px solid rgba(255, 198, 0)'}}
                        onClick = { onAceptDialog}
                    >
                        Aceptar
                    </Button>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" onClick = {onCloseDialog }>Cancelar</Button>
                </Grid>
            </Grid>
        </StandardDialog>
    );
};

DialogConfirm.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onAceptDialog: PropTypes.func.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
}

export default DialogConfirm;